export const gridHeaderDropdownStyle = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    container: (provided) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        boxShadow: 'none',
        marginLeft: '6px',
        paddingBottom: '0px',
        width: '160px',
        '&:hover': {
            borderColor: '#d3d4d8'
        },
        zIndex: '3'
    }),
    control: (provided, state) => ({
        ...provided,
        boxShadow: 'none',
        borderRadius: '8px',
        height: 'auto',
        minHeight: '38px',
        paddingBottom: '5px',
        width: '160px',
        maxWidth: '200px',
        '&:hover': {
            borderColor: '#006d9e',
            boxShadow: 'none',
        },
        '&:visited': {
            borderColor: '#006d9e',
            boxShadow: 'none',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        paddingTop: '5px',
        width: '160px',
        minWidth: '160px',
        color: '#343A40',
        fontSize: '13px'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        paddingTop: '6px',
        paddingBottom: '7px',
        color: '#373737',
        '& svg': {
            opacity: '0'
        },
        paddingRight: '0px'
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: '0px',
        marginRight: '0px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided, state) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        paddingTop: '1px',
        paddingBottom: '1px',
        backgroundColor: state.isFocused ? '#0D6EFD' : '#ffffff',
        color: state.isFocused ? '#ffffff' : '#222222',
        '&:hover': {
            backgroundColor: state.isFocused ? '#0D6EFD !important' : '#ffffff',
            color: state.isFocused ? '#ffffff' : '#222222',
            outline: 0,
        },
        fontSize: '13px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        position: 'absolute',
        right: '-3px',
        top: '50%',
        paddingTop: '2px',
        transform: 'translateY(-50%)',
        backgroundSize: "12px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 0.75rem center",
        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e")'
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: '1px !important',
        maxWidth: '200px',
        overflow: 'hidden',
    }),
    menuList: (provided) => ({
        ...provided,
        fontSize: '13px'
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingRight: '24px',
        paddingTop: '2px',
        width: "160px",
        minWidth: '160px',
        position: 'static',
        paddingLeft: '4px'
    }),
    singleValue: (provided) => ({
        ...provided,
        width: '150px',
        maxWidth: 'calc(100% - 24px)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        paddingTop: '5px',
        fontWeight: "normal",
        paddingRight: '24px',
        textOverflow: 'ellipsis',
        fontSize: '13px'
    }),
};
